import { useQuery } from "@tanstack/react-query";
import {
  getJointBillServiceProviderBillPlans,
  getSelectedJointBillServiceProviderBillPlans,
} from "./services";
import type {
  IJointBillServiceProviderBillPlan,
  ISelectedJointBillServiceProviderBillPlan,
} from "./types";

export const useJointBillServiceProviderBillPlansQuery = (
  jointBillServiceId: number,
  enabled?: boolean,
) =>
  useQuery<IJointBillServiceProviderBillPlan[]>({
    queryKey: ["jointBillServiceProviderBillPlans", jointBillServiceId],
    queryFn: () => getJointBillServiceProviderBillPlans({ jointBillServiceId }),
    enabled,
  });

export const useSelectedJointBillServiceProviderBillPlansQuery = () =>
  useQuery<ISelectedJointBillServiceProviderBillPlan>({
    queryKey: ["selectedJointBillServiceProviderBillPlans"],
    queryFn: () => getSelectedJointBillServiceProviderBillPlans(),
    staleTime: Infinity,
  });
